import React, { Component } from 'react'

import '../style/checkbox.scss'

export default class Checkbox extends Component {
    render() {
        const { title = false, color = "", style = {}, onChange = () => {}, active = false, isDisabled = false } = this.props;
        return (
            <div className="switch-holder" style={style}>
                <span>
                    {title}
                </span>
                <label className="switch">
                    <input type="checkbox" 
                        disabled={isDisabled}
                        //defaultChecked={active} 
                        checked={active}
                        onChange={(e) => {onChange && onChange(e)}} />
                    <span className={"slider round " + color}></span>
                </label> 
            </div>
        )
    }
}
